import idx from 'idx';
import reduce from 'lodash/reduce';
import first from 'lodash/first';
import sortBy from 'lodash/sortBy';

const Utils = (revisionVotes) => {
  const votes = idx(revisionVotes, _ => _.votes) || [];
  const revision = idx(revisionVotes, _ => _.revision) || { thumbnails: [] };

  const thumbnailImage = first(revision.thumbnails);
  const numVotes = Object.keys(votes).length;
  const numComments = reduce(votes, (mem, vote) => (vote.comment ? mem + 1 : mem), 0);
  const totalScore = reduce(votes, (mem, vote) => (mem + vote.score * vote.weight), 0);
  const totalWeight = reduce(votes, (mem, vote) => (mem + vote.weight), 0);
  const averageScore = numVotes > 0 ? Math.round((totalScore / totalWeight) * 10) / 10 : 0;

  return { averageScore, numVotes, numComments, thumbnailImage };
};

const WEIGHT_OPTIONS = [{
  field: 1,
  label: 'Less',
}, {
  field: 2,
  label: 'Normal',
}, {
  field: 3,
  label: 'More',
}];

const getClientLabel = (client) => {
  if (!client) {
    return 'The client';
  }

  if (client.first_name && client.last_name) {
    return `${client.first_name} ${client.last_name}`;
  }

  return client.username;
}

const getParticipantEmail = (email) => {
  if (!email) {
    return '';
  }

  if (email.endsWith('noemailprovided.com')) {
    return 'anonymous';
  }

  return email;
}

const sortRevisionsByScore = (revisions) => sortBy(revisions, (rev) => -Utils(rev).averageScore);

export { WEIGHT_OPTIONS, getClientLabel, getParticipantEmail, sortRevisionsByScore };
export default Utils;



// WEBPACK FOOTER //
// ./focus_groups/utils.js